var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_255",
    "data-name": "Grupo 255",
    transform: "translate(-38.208 841.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146",
    transform: "translate(62.349 -825.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86",
    "data-name": "Rect\\xE1ngulo 86",
    width: 15,
    height: 59,
    rx: 7.5,
    transform: "translate(-0.14 0.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_93",
    "data-name": "Rect\\xE1ngulo 93",
    width: 15,
    height: 59,
    rx: 7.5,
    transform: "translate(26.86 0.225)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPause);
export default __webpack_public_path__ + "static/media/playerPause.fbb977304373a7b740c6d76d56a41ceb.svg";
export { ForwardRef as ReactComponent };